import { useEffect, useRef } from 'react'
import { useAccount, useConnect } from 'wagmi'
import { isSafeApp } from './isSafeApp'

export function useSafeAutoConnect(): void {
  const { connect, connectors } = useConnect()
  const { isConnected } = useAccount()
  const attempted = useRef(false)

  useEffect(() => {
    if (attempted.current || isConnected || !isSafeApp()) {
      return
    }
    const safeConnector = connectors.find((c) => c.id === 'safe')
    if (safeConnector) {
      attempted.current = true
      connect({ connector: safeConnector })
    }
  }, [connect, connectors, isConnected])
}
